import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { formatPrice } from "../lib/api";

export default function ProductCard({ product, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.8, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className="product-card group"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/product/${product.slug}`} className="block">
        <div className="relative aspect-[3/4] overflow-hidden bg-graphite">
          {product.is_new && (
            <span className="absolute top-4 left-4 z-10 overline bg-carbon/80 px-3 py-1">Nuevo</span>
          )}
          {product.compare_at_price && (
            <span className="absolute top-4 right-4 z-10 overline bg-gold text-carbon px-3 py-1">Edición</span>
          )}
          {product.images?.[0] && (
            <img
              src={product.images[0]}
              alt={product.name}
              loading="lazy"
              className="product-img w-full h-full object-cover"
            />
          )}
          <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-carbon/90 to-transparent pointer-events-none" />
        </div>
        <div className="pt-5 pb-2">
          {product.brand && (
            <p className="overline mb-1">{product.brand}</p>
          )}
          <h3 className="font-heading text-xl text-ivory tracking-tight leading-tight group-hover:text-gold transition-colors">
            {product.name}
          </h3>
          <div className="flex items-baseline gap-3 mt-2">
            <span className="price-card">{formatPrice(product.price)}</span>
            {product.compare_at_price && (
              <span className="text-sm text-ivory/40 line-through" style={{ fontFamily: "Arial, sans-serif" }}>{formatPrice(product.compare_at_price)}</span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
